import { useMemo, useState } from "react";
import { PracticeGrid } from "./examples/practice-grid";
import { GuidePreview } from "./guide-preview";
import { makePracticeWorkbook } from "./payroll-edit-workbook";
export const PayrollEditExample = () => {
  const [edits, setEdits] = useState<Record<string, string>>({});
  const [version, setVersion] = useState(0);
  const sheet = useMemo(() => makePracticeWorkbook(200, edits), [edits]);
  return (
    <GuidePreview
      id="payroll-edit-example"
      label="Payroll grid preview"
      caption="Select C2 and enter 250. D2 shows the new total. You can edit any cell in this sample workbook."
      onReset={() => {
        setEdits({});
        setVersion((v) => v + 1);
      }}
    >
      <PracticeGrid
        key={version}
        sheet={sheet}
        editedCellIds={Object.keys(edits)}
        onCommit={(raw, cellId) => {
          setEdits((current) => ({ ...current, [cellId]: raw }));
        }}
      />
    </GuidePreview>
  );
};
